import React from "react";
import "./PostContent.scss";
import { HeadingSmall } from "@tumomento/ui";
import { PostRichText } from "../PostRichText/PostRichText";
import { parseDate } from "@/utils/functions";
import { QuotationPostCard } from "../../QuotationPostCard";
import { useDimensions } from "@/hooks/useDimensions";
import { ContentTable } from "../../ContentTable";


export const PostContent = ({ blog }: any) => {
  const { isMobile } = useDimensions();
  const subtitles = (() => {
    try {
      const data = JSON.parse(blog.body.raw).content as any[];
      return data
        .filter((c) => c.nodeType == "heading-2")
        .map((c) =>
          (c.content as any[]).reduce(
            (acc, d) => acc + ((d.value ?? "") as string).trimStart().trimEnd(),
            ""
          )
        );
    } catch {
      return [];
    }
  })();
  return (
    <div className="postContent">
      <div className="postContent__Card">
        <div className="postContent__Card__Left">
          <div className="postContent__Card__Line" />
          {/* <HeadingSmall color="green2">
            {blog.category[0]}
            <br />
            Fecha en {parseDate(blog.publishDate)}
          </HeadingSmall> */}
          <div className="mt-4 flex col g-4 sticky-element">
            <ContentTable subtitles={subtitles} />
            {!isMobile && <QuotationPostCard />}
          </div>
        </div>
        <div className="postContent__Card__Right">
          <div className="wrapRichTech">
            <PostRichText richText={blog.body} />
          </div>
        </div>
      </div>
    </div>
  );
};
